import React, { useState } from 'react';
import '../styles/EthicsAndValues.css';

const EthicsAndValues = () => {
  const [activeCard, setActiveCard] = useState(null);
  const values = [
    {
      icon: 'fas fa-lightbulb',
      title: 'Innovation',
      tagline: 'The world moves on innovation.',
      points: [
        'Investing in research and development',
        'Encouraging a culture of creativity and innovation',
        'Driving continuous improvement in healthcare solutions',
        'Embracing new technologies to improve patient outcomes'
      ]
    },
    {
      icon: 'fas fa-handshake',
      title: 'Integrity',
      tagline: 'Flawless execution.',
      points: [
        'Operating with transparency and honesty',
        'Demonstrating accountability in all actions',
        'Ensuring compliance with industry regulations',
        'Building trust with patients, customers, and partners'
      ]
    },
    {
      icon: 'fas fa-heart',
      title: 'Responsibility',
      tagline: 'We own our actions.',
      points: [
        'Supporting initiatives that benefit public health',
        'Encouraging ethical decision-making at all levels',
        'Prioritizing safety, sustainability, and social responsibility',
        'Taking ownership of our impact on society and the environment'
      ]
    },
    {
      icon: 'fas fa-bolt',
      title: 'Agility',
      tagline: 'We move with speed in a dynamic environment.',
      points: [
        'Leveraging technology to enhance efficiency',
        'Encouraging innovation and calculated risk-taking',
        'Quickly adapting to industry changes and challenges',
        'Developing flexible strategies to meet customer needs'
      ]
    },
    {
      icon: 'fas fa-users',
      title: 'Respect',
      tagline: 'We run admiration throughout.',
      points: [
        'Supporting a culture of mutual respect and fairness',
        'Encouraging open communication and collaboration',
        'Valuing diversity and fostering inclusivity in the workplace',
        'Recognizing and appreciating contributions from all team members'
      ]
    },
    {
      icon: 'fas fa-hands-helping',
      title: 'Community',
      tagline: 'We are committed to the communities we serve.',
      points: [
        'Advocating for better healthcare accessibility',
        'Supporting local initiatives and charitable causes',
        'Building strong relationships with local communities',
        'Partnering with NGOs to drive meaningful social impact'
      ]
    },
    {
      icon: 'fas fa-user-tie',
      title: 'Customer Focus',
      tagline: 'Customer satisfaction is our prime goal.',
      points: [
        'Continuously gathering feedback for improvement',
        'Providing exceptional customer service and support',
        'Ensuring transparency in pricing and product information',
        'Putting customers\' needs at the center of decision-making'
      ]
    }
  ];

  const handleCardClick = (index) => {
    setActiveCard(activeCard === index ? null : index);
  };

  return (
    <div className="ethics-values-page">
      <div className="header-section">
        <h1 className="section-titleEV">Our Core Values</h1>
        <p className="section-subtitleEV">Guiding principles that define who we are and how we operate</p>
      </div>
      <div className="values-container">
        {values.map((value, index) => (
          <div 
            key={index} 
            className={`value-card ${activeCard === index ? 'active' : ''}`}
            onClick={() => handleCardClick(index)}
          >
            <div className={`card-front ${activeCard === index ? 'hidden' : ''}`}>
              <div className="card-icon">
                <i className={value.icon}></i>
              </div>
              <h2 className="card-title">{value.title}</h2>
              <p className="card-tagline">{value.tagline}</p>
            </div>
            <div className={`card-back ${activeCard === index ? 'visible' : ''}`}>
              <h3 className="back-title">{value.title}</h3>
              <ul className="value-points">
                {value.points.map((point, i) => (
                  <li key={i} className="point-item">
                    <span className="point-bullet">•</span> {point}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default EthicsAndValues;